import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import ProductCard from '@zenbusiness/dashboard-components/ProductCard';
import { PropTypes } from 'prop-types';

import { dataTrackingPropsType } from '#client/utils/reporting';
import { buildCartUrl } from '#client/utils/urls';

import { PRODUCT_CARD_STATUS } from '../utils/constants';

const PRODUCT = 'domain_name_privacy';

const DomainPrivacyProductCard = ({
  isPurchased,
  isPurchaseAllowed = true,
  onLearnMoreClick,
  dataTrackingProps
}) => {
  const { businessEntityUuid } = useBusinessEntity();

  return (
    <ProductCard
      description="Extra security measure to keep private info from being public."
      eventProps={dataTrackingProps}
      imageUrl="https://res.cloudinary.com/zenbusiness/q_auto/v1/shared-assets/s2/vector/domain-name-privacy.svg"
      status={isPurchased ? PRODUCT_CARD_STATUS.PURCHASED : null}
      primaryCta={{
        label: 'Learn more',
        modalName: PRODUCT
      }}
      secondaryCta={{
        label: isPurchased ? 'Add another' : 'Buy now',
        url: buildCartUrl(isPurchaseAllowed ? PRODUCT : 'domain_name_reg', {
          businessEntityUuid
        })
      }}
      onCtaClick={onLearnMoreClick}
      title="Domain Privacy"
    />
  );
};

DomainPrivacyProductCard.propTypes = {
  isPurchaseAllowed: PropTypes.bool.isRequired,
  isPurchased: PropTypes.bool.isRequired,
  onLearnMoreClick: PropTypes.func.isRequired,
  dataTrackingProps: dataTrackingPropsType
};

export default DomainPrivacyProductCard;
